<template>
  <Drawer
    v-model="modalShow"
    :title="modalTitle"
    :width="70"
    @on-visible-change="getModalChange"
  >
    <div class="content">
      <div class="content-left">
        <div class="search-line">
          <Input
            v-model="schoolName"
            class="search-input"
            placeholder="请输入学校名称"
          ></Input>
          <Cascader
            v-model="area"
            placeholder="所属行政区"
            :data="regionDataList"
            class="search-input-long"
            @on-change="handelAreaChange"
          ></Cascader>
          <Button type="primary" @click="handleSearchSchool">搜索</Button>
        </div>
        <RadioOrCheckboxTable v-model="selectSchoolList" :show-page="true" unique-key="orgId" :table-loading="tableLoading" :table-column="tableColumn" :select-type="2" :table-data="schoolList" :table-total="schoolPageInfo.total" :table-current="schoolPageInfo.pageNum" @pageChange="handlePageChange"></RadioOrCheckboxTable>
      </div>
      <div class="content-right">
        <div>选中学校{{ selectSchoolList.length>0?`（${selectSchoolList.length}）`:'' }}</div>
        <div v-if="selectSchoolList.length>0" class="select-content">
          <div v-for="item in selectSchoolList" :key="item.orgId" class="content-line">
            <span>{{ item.name }}</span>
            <Icon type="md-close"></Icon>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-bottom">
      <Button
        style="margin-right: 8px"
        @click="close"
      >取消</Button>
      <Button
        style="margin-right: 8px"
        type="primary"
        @click="handleSure"
      >确定</Button>
    </div>
  </Drawer>
</template>
<script>
import orderCenterApi from '@/request/orderCenter/index.js';
import operationAdmin from '@/request/operationAdmin/index.js';
import RadioOrCheckboxTable from '@c/Base/RadioOrCheckboxTable';
import { regionDataList } from '@/utils/dictionary';
export default {
  components: {
    RadioOrCheckboxTable
  },
  props: {
    planId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      areaCode: '',
      area: [],
      schoolName: '',
      modalTitle: '选择学校',
      modalShow: false,
      schoolPageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      pageSizeOpts: [10, 20, 50, 100],
      tableLoading: false,
      tableColumn: [{
        title: '学校名称',
        key: 'name',
        minWidth: 200
      }, {
        title: '区域',
        key: 'areaName',
        minWidth: 200
      }],
      schoolList: [],
      selectSchoolList: [],
      regionDataList: [],
      setLoading: false
    };
  },
  watch: {
    selectSchoolList(newVal) {
      console.log(newVal, '=====');
    }
  },
  created() {
    this.regionDataList = [...regionDataList];
  },
  methods: {
    handlePageChange(page) {
      this.schoolPageInfo.pageNum = page;
      this.getSchoolListData();
    },
    open() {
      this.schoolName = '';
      this.areaCode = '';
      this.area = [];
      this.schoolList = [];
      this.selectSchoolList = [];
      this.getSchoolListData();
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.area = value;
      this.areaCode = value[value.length - 1];
    },
    handleSearchSchool() {
      this.schoolPageInfo.pageNum = 1;
      this.getSchoolListData();
    },
    // 获取学校列表数据
    async getSchoolListData() {
      const params = {
        pageNum: this.schoolPageInfo.pageNum,
        pageSize: this.schoolPageInfo.pageSize,
        areaCode: this.areaCode,
        schoolName: this.schoolName,
        isPayWages: 1,
        unSelectPlanId: this.planId
      };
      this.schoolName ? (params.searchStr = this.schoolName) : '';
      this.tableLoading = true;
      const res = await operationAdmin.getSysSchoolsApi(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          item.id = item.orgId;
          return item;
        });
        this.schoolPageInfo.total = Number(res.message.total);
        // !this.firstGetData ? this.$emit('firstLoadData', this.schoolList) : '';
        // this.firstGetData = true;
      }
    },
    // 点击确定按钮
    async handleSure() {
      if (this.selectSchoolList.length === 0) {
        this.$Message.error('请先选择学校');
        return;
      }
      const schoolInfoList = this.selectSchoolList.map(item => {
        return {
          schoolId: item.orgId, // 学校Id
          schoolName: item.name // 学校名称
        };
      });
      const params = {
        planId: this.planId,
        schoolInfoList
      };
      this.$Spin.show();
      const res = await orderCenterApi.setListSchRelPlanApi(params);
      this.$Spin.hide();
      if (res.status === 200) {
        this.$Message.success('设置成功');
        this.$emit('refresh');
        this.close();
      }
    },
    getModalChange() {},
    handlePage() {

    },
    handlePageSize() {}
  }
};
</script>
<style lang="scss" scoped>
.btn-bottom{
  position: absolute;
  bottom: 0;
  left: 0;
  margin-top: 16px;
  border-top: 1px solid #eee;
  width: 100%;
  height: 45px;
  box-sizing: border-box;
  padding-right: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #fff;
}
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-input-long{
    width: 210px;
    margin-right: 16px;
  }
}
.content{
  display: flex;
  box-sizing: border-box;
  padding-bottom: 45px;
  .content-left{
    width: 65%;
  }
  .content-right{
    width: 35%;
    padding-left: 16px ;
  }
}
.select-content{
  background: rgba(204, 204, 204,0.5);
  padding: 16px 8px;
  min-height: 200px;
  max-height: 100%;
  overflow: scroll-y;
  margin-top: 16px;
  .content-line{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
  }
}
</style>
